<template>
  <section class="meeting-selection">
    <div class="meeting-selection-header">
      <div class="meeting-selection-title-container">
        <h3>Select a meeting</h3>
        <small v-if="!selectedMeeting">Click on a meeting in the table to select it.</small>
      </div>
      <k-toggle v-model="showAllMeetings"
      size="small"
      :class-id="`show-all-meetings-${$.uid}`"
      label="Show all meetings"
      ></k-toggle>
    </div>
    <div class="meeting-selection-body">
      <template v-if="!selectedMeeting">
        <k-table v-if="filteredTableRows.length > 0"
          :headers="kableHeaders"
          :rows="filteredTableRows"
          :max="5"
          :panel="false"
          :hideable="false"
          :show-controls="false"
          :support-row-click="true"
          @row-clicked="handleRowClick"
        ></k-table>
        <empty-placeholder v-else
          faIcon=""
          title="No meetings found"
          info="No meetings were found. If you feel something is missing please contact us."
        >
        </empty-placeholder>
      </template>
      <div v-else class="flexible-panel selected-meeting-container">
        <div class="selected-meeting-info">
          <h4>{{ selectedMeeting.name }}</h4>
          <p>Support function: <span class="support-function">{{ formattedSupportFunction }}</span></p>
          <p>{{ selectedMeeting.description }}</p>
          <div class="tags-container tags">
            <span v-for="tag in selectedMeeting.tags" :key="tag" class="secondary">{{ tag }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="clearSelection">
          Select different meeting
        </button>
      </div>
    </div>
  </section>
</template>

<style>
#add-ad-hoc-meeting-modal .flexible-panel.selected-meeting-container {
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
}
</style>

<style scoped>
.meeting-selection-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.meeting-selection-title-container {
  margin-bottom: 15px;
}

.meeting-selection-title-container small {
  font-style: italic;
}

.selected-meeting-info {
  flex: 1;
}

@media (max-width: 1024px) {
  .selected-meeting-info {
    flex: 1 1 100%;
  }
}
</style>

<script>
import KTable from '@base-components/tables/display/k-table.vue';
import KToggle from '@base-components/forms/k-toggle.vue';
import EmptyPlaceholder from '@base-components/empty-placeholder.vue';

export default {
  components: {
    KTable,
    EmptyPlaceholder,
    KToggle,
  },

  props: {
    meetings: {
      type: Array,
      required: true,
    },
    selectedMeeting: {
      type: Object,
    },
    userSupportFunction: {
      type: String,
    },
  },

  data() {
    return {
      showAllMeetings: false,
    };
  },

  computed: {
    kableHeaders() {
      return {
        name: {
          name: 'Meeting',
          type: 'string',
          sortable: true,
          filterable: true,
        },
        description: {
          name: 'Description',
          type: 'string',
        },
        support_function: {
          name: 'Support Function',
          type: 'pill',
          options: {
            type: 'primary',
          },
          sortable: true,
        },
        tags: {
          name: 'Tags',
          type: 'tags',
          sortable: true,
          filterable: false,
        },
        type: {
          name: 'Type',
          type: 'pill',
          sortable: false,
          options: {
            type: () => 'warning',
            slotContent: type => type,
          },
        },
      };
    },

    tableRows() {
      return this.meetings.map((meeting, index) => ({
        id: meeting.id,
        is_adhoc: meeting.is_adhoc,
        name: {
          text: meeting.name,
          key: index,
        },
        description: meeting.description,
        support_function: meeting.support_function,
        tags: {
          tags: meeting.tags || [],
        },
        type: meeting.is_adhoc ? 'Ad-Hoc' : null,
      }));
    },

    filteredTableRows() {
      if (this.showAllMeetings) {
        return this.tableRows;
      }
      return this.tableRows.filter(meeting => meeting.is_adhoc && (meeting.support_function === this.userSupportFunction || !this.userSupportFunction));
    },

    formattedSupportFunction() {
      return this.selectedMeeting?.support_function?.replace(/_/g, ' ');
    },
  },

  methods: {
    handleRowClick(row, index) { // eslint-disable-line no-unused-vars
      const selected = this.meetings.find(meeting => meeting.id === row.id);
      this.$emit('update:selectedMeeting', selected);
    },

    clearSelection() {
      this.$emit('update:selectedMeeting', undefined);
    },
  },
};
</script>
